const doc = [({"da":({"js":({"admin":({"agenda_item_element_speakers":({"create_card":({"create_agenda_item_element_speaker":"Tilføj taler"})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;